import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { UserPreferenceKeys } from '../../types/generated/UserPreferences.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateUserPreferenceMutationVariables = Types.Exact<{
  input: Types.UpdateClientPreferencesInput;
}>;


export type UpdateUserPreferenceMutation = { __typename?: 'Mutation', updateClientPreferences: { __typename?: 'UpdateClientPreferencesPayload', userClientPreferences?: { __typename?: 'UserClientPreferences', hasProvidedTranscriptionDiarizationConsent: boolean, allowShareTracking: boolean, aiAssistantPromptHidden: boolean, locales?: { __typename?: 'LocalePreferences', email?: Types.SupportedLocale | null, web?: Types.SupportedLocale | null } | null } | null } };


export const UpdateUserPreference = /*#__PURE__*/ gql`
    mutation UpdateUserPreference($input: UpdateClientPreferencesInput!) @stewardship(stewards: [VIEWER]) {
  updateClientPreferences(input: $input) {
    userClientPreferences {
      ...UserPreferenceKeys
    }
  }
}
    ${UserPreferenceKeys}` as unknown as DocumentNode<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

          

          export const useUpdateUserPreferenceMutation = (options?:MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) => useMutation(UpdateUserPreference, options);
          

          export type UpdateUserPreferenceMutationOptions = MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

          

          export type UpdateUserPreferenceMutationResult = ReturnType<typeof useUpdateUserPreferenceMutation>[1];

          
